import { render, staticRenderFns } from "./DSSButtonLine.vue?vue&type=template&id=87fe5836&"
import script from "./DSSButtonLine.vue?vue&type=script&lang=js&"
export * from "./DSSButtonLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports